const MOBILE_QUERY = '(max-width: 767px)';
const TARGET_SLIDER_ID = 'gp-carousel-gAX7ivGyEo';
const TARGET_ROOT_ID = 'gp-root-carousel-gAX7ivGyEo';
const TARGET_ITEM_SELECTOR = '.gem-slider-item-gAX7ivGyEo';

function enableNativeScroll(slider) {
  slider.setAttribute('data-keen-slider-disabled', '');
  slider.style.transform = 'none';
  slider.style.scrollBehavior = 'auto';
  slider.style.webkitOverflowScrolling = 'touch';
  slider.style.touchAction = 'pan-x';
  slider.style.scrollSnapType = 'none';

  slider.querySelectorAll(TARGET_ITEM_SELECTOR).forEach((item) => {
    item.style.transform = 'none';
    item.style.scrollSnapAlign = 'none';
  });
}

function bindDragScroll(slider) {
  if (slider.dataset.nativeDragBound === 'true') return;

  let isPointerDown = false;
  let startX = 0;
  let startScrollLeft = 0;

  const getClientX = (event) => {
    if ('touches' in event && event.touches.length > 0) return event.touches[0].clientX;
    if ('changedTouches' in event && event.changedTouches.length > 0) return event.changedTouches[0].clientX;
    return event.clientX;
  };

  const startDrag = (event) => {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    isPointerDown = true;
    startX = getClientX(event);
    startScrollLeft = slider.scrollLeft;
    slider.classList.add('is-dragging');
  };

  const moveDrag = (event) => {
    if (!isPointerDown) return;

    const currentX = getClientX(event);
    const deltaX = currentX - startX;
    slider.scrollLeft = startScrollLeft - deltaX;

    if (event.cancelable) {
      event.preventDefault();
    }
  };

  const endDrag = () => {
    if (!isPointerDown) return;

    isPointerDown = false;
    slider.classList.remove('is-dragging');
  };

  slider.addEventListener('pointerdown', startDrag);
  slider.addEventListener('pointermove', moveDrag);
  slider.addEventListener('pointerup', endDrag);
  slider.addEventListener('pointercancel', endDrag);
  slider.addEventListener('pointerleave', endDrag);

  slider.addEventListener('touchstart', startDrag, { passive: true });
  slider.addEventListener('touchmove', moveDrag, { passive: false });
  slider.addEventListener('touchend', endDrag);
  slider.addEventListener('touchcancel', endDrag);

  slider.dataset.nativeDragBound = 'true';
}

function initMobileCarouselFix() {
  const root = document.getElementById(TARGET_ROOT_ID);
  const slider = document.getElementById(TARGET_SLIDER_ID);

  if (!root || !slider) return;

  if (!window.matchMedia(MOBILE_QUERY).matches) return;

  enableNativeScroll(slider);
  bindDragScroll(slider);
}

document.addEventListener('DOMContentLoaded', initMobileCarouselFix);
window.addEventListener('load', initMobileCarouselFix);
document.addEventListener('shopify:section:load', initMobileCarouselFix);

const observer = new MutationObserver(() => {
  initMobileCarouselFix();
});

if (document.documentElement) {
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
